"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { PageBackground } from "../types";
import type { PuckBackground } from "./types";

/** Transparent children inherit their surrounding surface's text contrast. */
export const PuckSurfaceToneContext = createContext<PageBackground>("white");

export function usePuckSurfaceTone(background: PuckBackground): PageBackground {
  const inherited = useContext(PuckSurfaceToneContext);
  return background === "transparent" ? inherited : background === "cream" ? "white" : background;
}

export function PuckSurfaceTone({
  background,
  children,
}: {
  background: PuckBackground;
  children: ReactNode;
}) {
  const tone = usePuckSurfaceTone(background);
  return <PuckSurfaceToneContext.Provider value={tone}>{children}</PuckSurfaceToneContext.Provider>;
}
